import { render, staticRenderFns } from "./WaitListItemSortCell.vue?vue&type=template&id=2b1950e7"
import script from "./WaitListItemSortCell.vue?vue&type=script&lang=ts"
export * from "./WaitListItemSortCell.vue?vue&type=script&lang=ts"
import style0 from "./WaitListItemSortCell.vue?vue&type=style&index=0&id=2b1950e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports